<template>
  <div class="d-flex flex-column justify-content-center align-items-center h-100">
    <b-card v-if="!hasRegister" class="d-flex flex-column align-items-center strong-shadow">
      <div class="text-center mb-3">
        <img
            src="@/assets/img/auto_atendimento/veusinho-okay.png"
            width="150"
            alt="Veusinho"
            class="rounded-pill border border-success"
        >
      </div>
      <b-form-group :label="$t('auto_atendimento.cadastro.documento')">
        <b-input v-model="model.documento"/>
      </b-form-group>
      <b-form-group :label="$t('auto_atendimento.cadastro.nascimento')">
        <b-input v-model="model.nascimento"/>
      </b-form-group>
      <b-button variant="success mt-4" block @click="checkRegister">
        {{ $t('auto_atendimento.orcamentos.consultar') }}
      </b-button>
      <div class="text-center">
        <router-link :to="{name: 'vaa.index'}" class="btn btn-link">Home</router-link>
      </div>
    </b-card>

    <div v-else class="w-100 h-100 mt-5">
      <div class="d-flex jusfity-content-between align-items-center mt-4 mb-2">
        <h1 class="flex-fill">{{ $t('auto_atendimento.orcamentos.meusorcamentos') }}</h1>
        <router-link :to="{name: 'vaa.index'}" class="btn btn-outline-warning">
          <b-icon icon="arrow-left"/>
        </router-link>
      </div>

      <div class="rounded overflow-hidden">
      <b-card
          v-for="(orcamento, idx) in orcamentos"
          :key="idx"
          :class="{'w-100': true, 'rounded-0': !orcamento.collapsed, 'rounded mt-2 mb-2': orcamento.collapsed}"
          body-class="p-1"
      >
        <div class="d-flex">
          <div class="flex-fill">
            <h3>{{ orcamento.created_at | formatDate }}</h3>
            <b-collapse :id="orcamento.id">
              <pre>{{ orcamento }}</pre>
            </b-collapse>
          </div>
          <span class="d-flex align-items-center p-2">
            <b-button
                variant="gray"
                @click="() => {
                  $root.$emit('bv::toggle::collapse', orcamento.id);
                  orcamento.collapsed = !orcamento.collapsed
                }"
                pill
            >
              <i :class="{'fas': true, 'fa-chevron-down': !orcamento.collapsed, 'fa-chevron-up': orcamento.collapsed}" />
            </b-button>
          </span>
        </div>
      </b-card>
      </div>

    </div>
  </div>
</template>

<script>
// import Cookies from "js-cookie";
// import axios from "axios";

export default {
  name: "Orcamentos",
  computed: {
    // hasRegister() {
    //   if (Cookies.get('user_hash')) {
    //     return true
    //   }
    //   return null
    // }
  },
  data() {
    return {
      hasRegister: false,
      model: {
        documento: null,
        nascimento: null
      },
      orcamentos: [
        {id: '1', collapsed: false, created_at: '2021-02-14'},
        {id: '2', collapsed: false, created_at: '2021-02-15'},
        {id: '3', collapsed: false, created_at: '2021-02-16'},
        {id: '4', collapsed: false, created_at: '2021-02-17'}
      ]
    }
  },
  methods: {
    checkRegister() {
      // axios.post('url de verificação', {
      //   params: {
      //     id_orcamento: this.$route.params.id,
      //     documento: this.model.documento,
      //     nascimento: this.model.nascimento
      //   }
      // }).then(response => {
      //   Cookies.set('user_hash', response.data.user_id, {expires: 3})
      // })
      this.hasRegister = true
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-gray:hover {
  background-color: #dddfeb!important;
}
</style>
